<template>
  <DBox
    :id="'cmp-catalog-product-sidewindow-stock_supply_order'"
    :addButton="false"
    :addLink="false"
  >
    <div style="display: flex; flex-direction: column; height: 100%">
      <div class="ut-fh">
        <NTable
          class="dbox1"
          id="catalog-releases-sidewindow-related_tracks"
          :config="tableConfig"
          :headers="Headers"
          :items="list"
          height="170px"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr>
              <td v-bind="tdcon('supplier_order')">
                <span
                  @click.stop="(e) => onRowClicked(item)"
                  class="txtov ut-link ut-text-accent5"
                  >{{ item["supplier_order_date"] }}</span
                >
              </td>
              <td v-bind="tdcon('supplier')">
                <span
                  @click.stop="(e) => onSupplierOrderClicked(item)"
                  class="txtov ut-link ut-text-accent5"
                  >{{ item["supplier_name"] }}</span
                >
              </td>
              <td v-bind="tdcon('order_id')">
                <span
                  @click.stop="(e) => onRowClicked(item)"
                  class="txtov ut-link ut-text-accent5"
                  >{{ item["supplier_order_id"] }}</span
                >
              </td>
              <td v-bind="tdcon('qty')">
                <span class="txtov">{{ item["order_qty"] }}</span>
              </td>
            </tr>
          </template>
        </NTable>
      </div>
    </div>
  </DBox>
</template>
  <script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { ProductsService } from "../../services/products.service";
import FileDownload from "js-file-download";
import { distributionSupplierListLDTRoutes,distributionSupplierOrderListLDTRoutes } from "../../../distribution/router/routes";
export default {
  props: {
    selectedProductDetails: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    Headers: function () {
      return [
        createTableHeader("supplier_order", {
          mw: 120,
          text: this.$t("supplier_order"),
        }),
        createTableHeader("supplier", {
          f: 1.1,
        }),
        createTableHeader("order_id", {
          f: 0.5,
        }),
        createTableHeader("qty", {
          f: 0.5,
          ta: "right",
        }),
      ];
    },

    list: function () {
      return this.selectedProductDetails.orderlines || [];
    },
  },

  methods: {
    onRowClicked(item) {
      this.$router.push({
        name: distributionSupplierOrderListLDTRoutes.names.tab,
        params: {
          supplier_order_id: item.supplier_order_id,
          tab: "overview",
        },
      });
    },
    onSupplierOrderClicked(item) {
      this.$router.push({
        name: distributionSupplierListLDTRoutes.names.tab,
        params: {
          supplier_id: item.supplier_id,
          tab: "overview",
        },
      });
    },
  },
};
</script>
  <style lang="scss">
.cmp-catalog-product-sidewindow-stock_supply_order {
  .container-flex {
    display: flex;
    align-items: center;
    span {
      flex: 1;
      padding-right: 3px;
    }
    // img {
    //   flex: 0.1;
    // }
  }
  .dt-ntable {
    // --ntable-height: 170px;
  }
  .i-icon-box {
    background-color: var(--emerald);
    color: white;
    font-weight: 400;
    display: grid;
    place-items: center;
  }
}
</style>
  